import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS } from '@contentful/rich-text-types';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import Button from 'components/Core/Button';
import SubscribeForm from 'components/Form/SubscribeForm';
import { SectionTryDemo, FormContainer } from './styles';

const subheadOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <>{children}</>,
  },
};
const InlineCta = (props) => {
  const {
    dataPosition,
    dataTestId,
    formType,
    subHead,
    description,
    title,
    buttonTitle,
    buttonLinkTo,
    buttonColor,
    utm,
    useModalForm,
    modalForm,
    theme,
  } = props;

  const [search, setSearch] = useState(undefined);
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  useEffect(() => {
    setSearch(window?.location?.search);
  }, []);

  return (
    <SectionTryDemo data-testid="split-conversion-panel">
      <div className="section-try-demo--container">
        <div className="section-try-demo--text-container">
          {subHead && <p className="section-try-demo--small-title font-overline">{subHead}</p>}
          <p className="section-try-demo--title font-h1">{title}</p>
          {description?.raw && (
            <p className="section-try-demo--small-title">
              {renderRichText(description, subheadOptions)}
            </p>
          )}
        </div>

        {(useModalForm || buttonLinkTo) && (
          <div className="section-try-demo--button-container">
            <Button
              dataPosition="Body Conversion Panel - Split CTA"
              type={buttonColor}
              shadow={false}
              {...(buttonLinkTo ? { to: `${buttonLinkTo}${utm && search ? search : ''}` } : {})}
              {...(useModalForm ? { onClick: () => toggleIsModalOpen(true) } : {})}
            >
              {buttonTitle}
            </Button>
          </div>
        )}
        {!useModalForm && modalForm && (
          <FormContainer theme={theme}>
            <SubscribeForm
              dataPosition={dataPosition}
              inlineMarketingForm={modalForm}
              buttonLabel={buttonTitle}
              notificationMessage={modalForm.thankyou || 'Thanks for subscribing!'}
              notificationSnack={modalForm.thankyouSnackbar}
              shouldRedirect={false}
              shadow={false}
              onSuccess={modalForm.onSuccess}
              revealProps={{
                styles: 'subscribe-form--legal-info',
              }}
            />
          </FormContainer>
        )}
      </div>
      {useModalForm && (
        <ModalMarketingForm
          dataPosition={dataPosition}
          formType={formType}
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          inlineMarketingForm={modalForm}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      )}
    </SectionTryDemo>
  );
};

InlineCta.propTypes = {
  subHead: PropTypes.string,
  title: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonLinkTo: PropTypes.string,
};

export default InlineCta;
